import { render, staticRenderFns } from "./invite-design-add-or-update.vue?vue&type=template&id=86d128f8&scoped=true&"
import script from "./invite-design-add-or-update.vue?vue&type=script&lang=js&"
export * from "./invite-design-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86d128f8",
  null
  
)

export default component.exports